import { render, staticRenderFns } from "./CheckTableBodyItem.vue?vue&type=template&id=57fa8e9f&scoped=true&"
import script from "./CheckTableBodyItem.vue?vue&type=script&lang=js&"
export * from "./CheckTableBodyItem.vue?vue&type=script&lang=js&"
import style0 from "./CheckTableBodyItem.vue?vue&type=style&index=0&id=57fa8e9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa8e9f",
  null
  
)

export default component.exports